/**
 * Returns a grouped Object from a given array of Objects where a certain key of these objects are expected to be the same
 * what ramda js states as Splits a list into sub-lists stored in an object, based on the result of calling a String-returning
 * function on each element, and grouping the results according to values returned.
 * @param {Object[]} list - The array to consider.
 * @param {(Function)} criteria - function
 * @returns {Map} an object where keys are the values of each object's criteria key.
 * @example
 *
 *   groupBy([{a: 4, b: 1}, {a: 4, b: 3}, {a: 5, b: 1}, {a: 5, b: 3}], (item) => item.a);
 *   // { 4: [ { a: 4, b: 1 }, { a: 4, b: 3 } ], 5: [ { a: 5, b: 1 }, { a: 5, b: 3 } ] }
 */

const groupBy = (list, keyGetter) => {
  const map = new Map();
  list?.forEach(item => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
};

export default groupBy;
